import { render, staticRenderFns } from "./PrintCorpFooter.vue?vue&type=template&id=2c14f718&scoped=true&"
import script from "./PrintCorpFooter.vue?vue&type=script&lang=js&"
export * from "./PrintCorpFooter.vue?vue&type=script&lang=js&"
import style0 from "./PrintCorpFooter.vue?vue&type=style&index=0&id=2c14f718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14f718",
  null
  
)

export default component.exports